export default __webpack_public_path__ + "static/char-s-sp01-zh-Hans-3b83079b2cc17b0e5f53e6c264eb20e0.webp";